import { _ as _define_property } from "@swc/helpers/_/_define_property";
export var ApprovalMethodDateType = /*#__PURE__*/ function(ApprovalMethodDateType) {
    ApprovalMethodDateType["Auto"] = "auto";
    ApprovalMethodDateType["Manual"] = "manual";
    return ApprovalMethodDateType;
}({});
export class ApprovalMethodDateModel {
    static fromDTO(dto) {
        return new ApprovalMethodDateModel(dto);
    }
    static makeAuto(approveDate) {
        return new ApprovalMethodDateModel({
            type: "auto",
            auto: {
                approveDate
            }
        });
    }
    static makeManual() {
        return new ApprovalMethodDateModel({
            type: "manual"
        });
    }
    isAutoApproval() {
        return this.data.type === "auto";
    }
    autoApprovalDate() {
        return this.data.type === "auto" ? new Date(this.data.auto.approveDate) : null;
    }
    toDTO() {
        return this.data;
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = data;
    }
}
